// extracted by mini-css-extract-plugin
module.exports = {"container":"wE37T","messageBody":"Fplmd"};